import DealerError from './DealerError.js'

export default class ContractError extends DealerError {}
